import React, { PureComponent } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const DELAY = 200;

class PageLoaderBar extends PureComponent {
    static propTypes = {
        isActive: PropTypes.bool,
    };

    static defaultProps = {
        isActive: false,
    };

    state = {
        showLoader: false,
    };


    componentWillReceiveProps({ isActive }) {
        if (isActive === false) {
            this.delayToggleLoader(isActive);
        } else {
            this.cleanupTimers();
            this.setState({ showLoader: isActive });
        }
    }

    componentWillUnmount() {
        this.cleanupTimers();
    }

    delayToggleLoader = debounce(function(showLoader) {
        this.setState({
            showLoader,
        });
    }, DELAY);

    cleanupTimers() {
        this.delayToggleLoader.cancel();
    }

    render() {
        const { showLoader } = this.state;

        return (
            <div className={classnames('page-loader-bar-container', {
                'page-loader-bar-container__is-active': showLoader,
            })}>
                <div className={'page-loader-bar'}></div>
            </div>
        );
    }
}

export default PageLoaderBar;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/page-loader-bar/index.js